// Hook TanStack Query — statut d'acces Systeme C du user courant (GET /api/me).
// FRAG2 : le SPA gate ses ecrans sur ce statut (etage 1 entitlement + etage 2
// role GEST), JAMAIS sur les groupes Azure AD. Un 403 GEST_USER_NOT_PROVISIONED
// (user absent de ug.Users — provisionOnMiss:false) remonte en ApiForbiddenError ;
// App.tsx le mappe sur l'ecran « acces via votre administrateur ».
import { useQuery } from '@tanstack/react-query';
import { api } from '@gs/api-client';

export type SystemCRole = 'UTILISATEUR' | 'GESTIONNAIRE' | 'ADMIN';

export interface Me {
  userId: string;
  email: string;
  fullName: string;
  /** A3 : company du contexte EFFECTIF (compagnie choisie si bascule, sinon home). */
  companyId: string;
  isCorporateAdmin: boolean;
  /** A3 : true si le contexte servi est une bascule corporate (pas le home). */
  contextSwitched: boolean;
  /** Etage 1 (ADR-067) : module GEST actif pour la compagnie EFFECTIVE (ug.CompanyModules). */
  moduleEntitled: boolean;
  /** Etage 2 : role Systeme C bc_key GEST (ug.UserCompanyBcRoles) — null si aucun. */
  role: SystemCRole | null;
  /** Etage 3 (E3a) : dirige au moins une equipe (gest.Teams.director_email). */
  isTeamDirector: boolean;
}

/**
 * Visibilite « management » (admin | manager | director) pour la nav et les
 * affordances SPA — miroir CLIENT de la garde serveur M-402 (routes comites).
 * AUCUN god-path corporate (doctrine FRAG2 fail-closed) : un corporate admin
 * sans role GEST n'est pas management. L'autorite reelle reste le serveur.
 */
export function isManagementMe(me: Me | undefined): boolean {
  if (!me) return false;
  return me.role === 'ADMIN' || me.role === 'GESTIONNAIRE' || me.isTeamDirector;
}

export function useMe(enabled: boolean) {
  return useQuery({
    queryKey: ['gest', 'me'],
    queryFn: () => api.get<Me>('/api/me'),
    enabled,
    // Un refus d'acces est un ETAT stable, pas une erreur transitoire : zero retry
    // (createGsQueryClient ne retry deja pas les 401/403 — ceinture locale).
    retry: false,
  });
}
